import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  email: string;
  first_name: string;
  last_name: string;
}

const initialState: InitialState = {
  email: "",
  first_name: "",
  last_name: "",
};

const userTransactionSlice = createSlice({
  name: "Save the user transaction",
  initialState,
  reducers: {
    updateUserTransaction(state, action) {
      state.email = action.payload?.email;
      state.first_name = action.payload?.first_name;
      state.last_name = action.payload?.last_name;
    },
    resetUserTransactionDetails(state) {
      state.email = initialState.email;
      state.first_name = initialState.first_name;
      state.last_name = initialState.last_name;
    },
  },
});

export const { updateUserTransaction, resetUserTransactionDetails } = userTransactionSlice.actions;
export default userTransactionSlice.reducer;
